import { useMemo } from 'react';
import { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { sizeOrder } from '../clothingSizeConstants';

const useSizeGroups = (
  items: Array<RefinementListItem & { group: string }>
) => {
  return useMemo(() => {
    return Array.from(new Set(items.map((item) => item.group))).sort((a, b) => {
      const aIndex = sizeOrder.get(a) ?? Infinity;
      const bIndex = sizeOrder.get(b) ?? Infinity;
      return aIndex - bIndex;
    });
  }, [items]);
};

export default useSizeGroups;
